const omega_summary = {
  Trinity_realname_remove_ck: {
    id: 'Trinity_realname_remove_ck',
    label: '点击解绑按钮'
  },
  trinity_rightidshow_sw: {
    id: 'trinity_rightidshow_sw',
    label: '统一实名首页展示'
  },
  trinity_idshow_ident_ck: {
    id: 'trinity_idshow_ident_ck',
    label: '统一实名点击去认证去埋点'
  },
  trinity_idshow_toastaway_sw: {
    id: 'trinity_idshow_toastaway_sw',
    label: '统一实名认证信息完善弹窗展示埋点'
  },
  trinity_idshow_toastident_sw: {
    id: 'trinity_idshow_toastident_sw',
    label: '统一实名认证信息完善展示埋点'
  },
  trinity_idshow_toastaway_ok_ck: {
    id: 'trinity_idshow_toastaway_ok_ck',
    label: '统一实名认证信息绑定展示'
  },
  trinity_idshow_toastident_go_ck: {
    id: 'trinity_idshow_toastident_go_ck',
    label: '统一实名认证信息完善点击'
  },
  trinity_idshow_toastaway_cancel_ck: {
    id: 'trinity_idshow_toastaway_cancel_ck',
    label: '统一实名认证信息绑定失败弹窗点击'
  },
  trinity_idshow_toastwrong_sw: {
    id: 'trinity_idshow_toastwrong_sw',
    label: '统一实名信息不一致展示'
  },
  trinity_idshow_toastwrong_ck: {
    id: 'trinity_idshow_toastwrong_ck',
    label: '统一实名信息不一致弹窗展示'
  },
  trinity_idshow_appeal_ck: {
    id: 'trinity_idshow_appeal_ck',
    label: '点击“以上实名不是我的”按钮埋点'
  },
  trinity_idshow_sw: {
    id: 'trinity_idshow_sw',
    label: '统一实名认证信息冲突页面展示'
  },
  trinity_id_ck: {
    id: 'trinity_id_ck',
    label: '实名认证点击埋点'
  },
  pub_trinity_id_sw: {
    id: 'pub_trinity_id_sw',
    label: '实名认证信息填写页展示'
  },
  pub_trinity_passer_face_auth_suc_sw: {
    id: 'pub_trinity_passer_face_auth_suc_sw',
    label: '实名认证信息乘客端人脸成功'
  },
  pub_trinity_passer_face_auth_fail_sw: {
    id: 'pub_trinity_passer_face_auth_fail_sw',
    label: '实名认证信息乘客端人脸失败'
  },
  pub_trinity_driver_face_auth_suc_sw: {
    id: 'pub_trinity_driver_face_auth_suc_sw',
    label: '实名认证信息司机端人脸成功'
  },
  pub_trinity_driver_face_auth_fail_sw: {
    id: 'pub_trinity_driver_face_auth_fail_sw',
    label: '实名认证信息司机端人脸失败'
  },
  pub_trinity_uniid_sw_bt: {
    id: 'pub_trinity_uniid_sw_bt',
    label: '获取实名状态'
  },
  pub_trinity_uniid_blockshow_login_ck: {
    id: 'pub_trinity_uniid_blockshow_login_ck',
    label: '未登录弹窗点击确认'
  },
  pub_trinity_uniid_blockshow_cancel_ck: {
    id: 'pub_trinity_uniid_blockshow_cancel_ck',
    label: '未登录弹窗点击取消'
  },
  pub_identity_faq_ck: {
    id: 'pub_identity_faq_ck',
    label: '常见问题'
  },
  pub_trinity_idcard_upload_fail_ck: {
    id: 'pub_trinity_idcard_upload_fail_ck',
    label: '身份证拍照上传失败'
  },
  pub_trinity_idcard_upload_suc_ck: {
    id: 'pub_trinity_idcard_upload_suc_ck',
    label: '身份证拍照上传成功'
  },
  pub_trinity_auth_unbound_suc_sw: {
    id: 'pub_trinity_auth_unbound_suc_sw',
    label: '实名冲突解绑成功'
  },
  pub_trinity_auth_unbound_fail_sw: {
    id: 'pub_trinity_auth_unbound_fail_sw',
    label: '实名冲突解绑失败'
  },
  pub_trinity_auth_submit__suc_ck: {
    id: 'pub_trinity_auth_submit__suc_ck',
    label: '实名冲突认证成功'
  },
  pub_trinity_auth_submit__fail_ck: {
    id: 'pub_trinity_auth_submit__fail_ck',
    label: '实名冲突认证失败'
  },
  pub_trinity_verification_sw_bt: {
    id: 'pub_trinity_verification_sw_bt',
    label: '验证码展示'
  },
  pub_trinity_idshow_appeal_ck: {
    id: 'pub_trinity_idshow_appeal_ck',
    label: '点击“以上实名不是我的”按钮埋点'
  },
  pub_trinity_removepop_sure_ck: {
    id: 'pub_trinity_removepop_sure_ck',
    label: '解绑弹窗点击确认'
  },
  pub_trinity_removepop_cancel_ck: {
    id: 'pub_trinity_removepop_cancel_ck',
    label: '解绑弹窗点击取消'
  },
  pub_trinity_infor_confirmation_submit_suc_ck: {
    id: 'pub_trinity_infor_confirmation_submit_suc_ck',
    label: '实名冲突绑定成功'
  },
  pub_trinity_infor_confirmation_submit_fail_ck: {
    id: 'pub_trinity_infor_confirmation_submit_fail_ck',
    label: '实名冲突绑定失败'
  },
  pub_trinity_show_conflict_sw: {
    id: 'pub_trinity_show_conflict_sw',
    label: '是否展示了新的冲突逻辑'
  },
  pub_identity_change_sw: {
    id: 'pub_identity_change_sw',
    label: '变更实名信息按钮展示'
  },
  pub_identity_change_ck: {
    id: 'pub_identity_change_ck',
    label: '变更实名信息按钮点击'
  }
}

export default omega_summary
